import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { CustomLabel, CustomError } from '../style'
import { Input, Table } from '../../assets'
import eyeSvg from '../../assets/images/eye.svg'

const InputWrapper = styled.div`
    background: ${Input.background};
    input {
        border-width: 1px;
        border-style: solid;
        border-color: ${(props) => (props.isBlue ? Input.borderColor : Table.action.border)};

        ::placeholder {
            color: ${Input.placeholder};
            opacity: 1;
        }
    }
`
const EyeContentWrapper = styled.div`
    background-color: red;
    height: 23px;
    margin-top: -30px;
    position: relative;
    float: right;
`
const EyePasswordWrapper = styled.div`
    position: absolute;
    right: 20px;
    z-index: 10; 
    img {
        cursor: pointer;
    }
`

const CustomInput = ({ isBlue, label, data, placeholder, type, name, showPassword, ...props }) => {
    const [hidePassword, setHidePassword] = useState(true)
    return (
        <InputWrapper isBlue={isBlue}>
            {label.toString() && <CustomLabel htmlFor={name}>{label}</CustomLabel>}
            <input
                className={`form-control ${data.error ? 'is-invalid' : ''}`}
                type={hidePassword ? type : 'text'}
                value={data.value}
                placeholder={placeholder}
                name={name}
                {...props}
            />
            {type === 'password' && showPassword && (
                <EyeContentWrapper className='row'>
                    <EyePasswordWrapper onClick={() => setHidePassword(!hidePassword)}>
                        <img src={eyeSvg} width={20} />
                    </EyePasswordWrapper>
                </EyeContentWrapper>
            )}
            {data.error && <CustomError>{data.error}</CustomError>}
        </InputWrapper>
    )
}

CustomInput.propTypes = {
    label: PropTypes.string,
    type: PropTypes.oneOf(['text', 'number', 'password', 'email']),
    placeholder: PropTypes.string,
    data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            value: PropTypes.string,
            error: PropTypes.string
        })
    ])
}

CustomInput.defaultProps = {
    label: '',
    placeholder: '',
    type: 'text',
    data: {
        value: '',
        error: ''
    }
}

export default CustomInput
